<div class="container" *ngIf="!user">
  <div id="googleLoginButton" *ngIf="!user"></div>
</div>
